import React from 'react';
import { motion } from 'framer-motion';
import '../css/contact.css';

export default function Contact() {
  return (
    <>
      <section className="contact-me">
        <div className="contact-container">

          <motion.div
            className="name-center"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
          >
            <h1>Ashar Naveed</h1>
            <p>
              Software Engineering Student passionate about creating innovative solutions.
              <br />
              Let's build the future together.
            </p>
          </motion.div>

          <motion.a
            href="mailto:asharnaveed.career@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="email-button"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.98 }}
          >
            <span>Send me an email</span>
          </motion.a>

          <motion.div
            className="availability"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <span className="icon">⚡</span>
            <div className="availability-text">
              <strong>Current availability</strong>
              <p>I'm looking for a full-time job.</p>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
}
